import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { AuthenticationResult } from '../models/authentication.model';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { InvisibleReCaptchaComponent } from '../../../../node_modules/ngx-captcha';
import { FormGroup, NgForm } from '../../../../node_modules/@angular/forms';

@Component({
  selector: 'app-auth-user-otp',
  templateUrl: './auth-user-otp.component.html',
  styleUrls: ['./auth-user-otp.component.css']
})
export class AuthUserOtpComponent extends AuthBaseComponent implements OnInit {
  public data: any = {};
  public loginOriginAction: string = "";
  public showCaptcha: boolean = false;
  public _countTimes: number = 0;
  private _form: NgForm;
  private _captchaResponse: string = null;
  private _captchaReady: boolean = false;

  @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;

  constructor(private renderer: Renderer2, protected modalService: ModalService, protected authService: AuthUserService) {
    super(modalService, authService);
  }
  ngOnInit() {
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2130' })
      .subscribe(res => console.log("sent elasticLog code:2130 - open window", res), error => console.log("sent elasticLog - open window error!", error));
    this.data = this.modalService.data;
    this.loginOriginAction = sessionStorage.getItem("loginOriginAction");
    sessionStorage.setItem("currentWindow", "סיסמה חד פעמית");
    sessionStorage.setItem("elasticCode", "2187");
    const element = this.renderer.selectRootElement('#pwOtp');
    if (element) {
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
  }

  captchaSuccess(captchaResponse: string): void {
    this._captchaResponse = captchaResponse;
    this.callServer();
  }
  captchaReady() {
    this._captchaReady = true;
  }
  submit(form): void {
    this._form = form;

    const element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element) {
      setTimeout(() => element.focus(), 0);
    }
    if (form.valid) {
      this.serverError = null;
      this.pending = true;
      if (this._captchaReady) {
        this.captchaElem.execute();
      }
      else {
        this.callServer();
      }
    }
    this.buildFormAccessibility();
  }

  private callServer() {
    this.authUserService.sendAuthData("ValidateOTP", { OTP: this._form.value.pwOtp, captchaResponse: this._captchaResponse })
      .subscribe((res: AuthenticationResult) => {
        if (res.Details.UserInputError == "OTPInvalid") {
          this.serverError = "הסיסמה אינה נכונה";
          if (this.captchaElem != null && this.showCaptcha) {
            this.captchaElem.resetCaptcha();
          }

          this.showCaptcha = res.Details.ShowOTPCaptcha == true;
          this._countTimes++;

          console.log("Failure", res.Details);
        } else if (res.Details.UserInputError == "ReCaptchaInvalid") {
          this.captchaElem.resetCaptcha();
          this.serverError = "הקאפצ'ה נכשלה";
        }
        else {
          this.modalService.close(res.Details);
        }
      }, () => this.pending = false,
        () => this.pending = false);
  }
}
